<template>
  <div></div>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import axios from 'axios'
import { computed, onBeforeMount } from '@vue/runtime-core'
import useFlows from '@/mixins/useFlows.js'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'
export default {
  props: {
    project: {
      type: String,
      default: ''
    },
    simulationAmount: {
      type: String,
      default: ''
    },
    editReservation: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    const { resetInvestFlow } = useFlows()
    const { isInt } = useGlobalHelpers()

    resetInvestFlow(-1)

    const projectId = computed(() => {
      return parseInt(props.project)
    })

    onBeforeMount(async () => {
      await store.dispatch('fetchWallets')
      
      // Check for project
      if (isInt(projectId.value)) {
        if (store.state.projects.project.id !== projectId.value) {
          await store.dispatch('getProject', projectId.value)
        }
      } else {
        store.dispatch('setError', {
          response: {
            custom: true,
            status: 500,
            data: {
              code: 'invalid_project'
            }
          }
        })
      }

      // Waiting list joins are refused without wallet balance (no reservations allowed), stop at the start of the flow
      if (
        store.state.projects.project?.state === 'reserved' &&
        !props.editReservation &&
        (store.state.wallets.wallet?.balance ?? 0) < (store.state.general.settings?.min_investment ?? 2000)
      ) {
        // Vouchers count as funds (voucher-only joins are accepted). Same source as invest/Amount.vue;
        // if this lookup fails, let the flow continue and leave it to the backend
        const vouchers = await axios
          .get(process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/investments/' + store.state.projects.project.id + '/currentInvested')
          .then((data) => data.data.vouchers)
          .catch(() => null)

        if (vouchers && !vouchers.length) {
          store.dispatch('setError', {
            response: {
              custom: true,
              status: 403,
              data: {
                code: 'no_wallet_balance'
              }
            }
          })
          // replace, not go(-1): resetInvestFlow may already have gone back once
          router.replace({
            name: 'project-details',
            params: { id: store.state.projects.project.id }
          })
          return
        }
      }

      router.push({
        name: 'invest-amount',
        params: {
          projectId: projectId.value,
          simulationAmount: props.simulationAmount,
          editReservation: props.editReservation
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped></style>
